/* ============================================================
   skinmade — Session-Anfrageformular
   Vanilla ES5, keine externen Libs.
   POST → window.SM_SESSIONS_API (skinmade-sessions-worker /sessions)
   Build: 2026-07-29
   ============================================================ */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var L = (document.documentElement.getAttribute('lang') || 'de').toLowerCase().indexOf('en') === 0 ? 'en' : 'de';
  var MSG = {
    de: { required: 'Bitte fülle alle Pflichtfelder aus.', email: 'Bitte gib eine gültige E-Mail-Adresse ein.', consent: 'Bitte stimme der Datenschutzerklärung zu.', sending: 'Wird gesendet…', rate: 'Zu viele Anfragen — bitte versuch es später nochmal.', generic: 'Es ist ein Fehler aufgetreten — bitte erneut versuchen.', network: 'Verbindung fehlgeschlagen — bitte prüfe deine Internetverbindung und versuch es erneut.' },
    en: { required: 'Please fill in all required fields.', email: 'Please enter a valid email address.', consent: 'Please accept the privacy policy.', sending: 'Sending…', rate: 'Too many requests. Please try again later.', generic: 'Something went wrong. Please try again.', network: 'Connection failed. Please check your internet and try again.' }
  }[L];

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function val(form, name) {
    var el = form.elements[name];
    if (!el) return '';
    return (el.value || '').replace(/^\s+|\s+$/g, '');
  }

  function init(form) {
    var submitBtn = form.querySelector('[data-sm-session-submit]');
    var errorBox = form.querySelector('[data-sm-session-error]');
    var successBox = document.querySelector('[data-sm-session-success]');
    var apiUrl = window.SM_SESSIONS_API || 'https://skinmade-sessions-worker.marcel-808.workers.dev/sessions';
    var submitLabel = submitBtn ? submitBtn.textContent.replace(/^\s+|\s+$/g, '') : 'Session anfragen';

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.hidden = false;
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    function setLoading(on) {
      if (!submitBtn) return;
      submitBtn.disabled = on;
      submitBtn.textContent = on ? MSG.sending : submitLabel;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var name = val(form, 'name');
      var email = val(form, 'email');
      var phone = val(form, 'phone');
      var zip = val(form, 'zip');
      var city = val(form, 'city');
      var consentEl = form.elements['consent'];
      var consent = !!(consentEl && consentEl.checked);

      // Client-Validierung
      if (!name || !phone || !zip || !city) {
        showError(MSG.required);
        return;
      }
      if (!EMAIL_RE.test(email)) {
        showError(MSG.email);
        return;
      }
      if (!consent) {
        showError(MSG.consent);
        return;
      }

      var payload = {
        name: name,
        email: email,
        phone: phone,
        zip: zip,
        city: city,
        consent: true,
        lang: L,
        company: (form.elements['company'] && form.elements['company'].value) || ''
      };

      var street = val(form, 'street');
      if (street) payload.street = street;

      var preferredDate = val(form, 'preferred_date');
      if (preferredDate) payload.preferred_date = preferredDate;

      var preferredTime = val(form, 'preferred_time');
      if (preferredTime) payload.preferred_time = preferredTime;

      var guests = val(form, 'guest_count');
      if (guests) payload.guest_count = guests;

      var message = val(form, 'message');
      if (message) payload.message = message;

      setLoading(true);

      fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.ok) {
          form.style.display = 'none';
          if (successBox) {
            successBox.hidden = false;
            if (successBox.scrollIntoView) {
              successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
          return null;
        }
        if (res.status === 429) {
          setLoading(false);
          showError(MSG.rate);
          return null;
        }
        return res.json().then(function (data) {
          setLoading(false);
          var msg = (data && data.error) ? data.error : MSG.generic;
          showError(msg);
        }, function () {
          setLoading(false);
          showError(MSG.generic);
        });
      }).catch(function () {
        setLoading(false);
        showError(MSG.network);
      });
    });
  }

  ready(function () {
    var forms = document.querySelectorAll('[data-sm-session-form]');
    for (var i = 0; i < forms.length; i++) {
      init(forms[i]);
    }
  });
})();
